














import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import { Approval } from '@/models/approval';
import { ApprovalApi } from '@/api/approval-api';
import { ApprovalHistory } from '@/models/approval-history';
import approvalDetails from '@/components/approval-details.vue';
import { Forbidden } from '@/models/forbidden-error';
import { NotFound } from '@/models/not-found-error';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';

const approvalApi = new ApprovalApi();
const userModule = namespace('user');

@Component({
    components: {
        approvalDetails,
    },
})
export default class ViewApproval extends Vue {
    public isLoading: boolean = true;
    public approval: Approval | null = null;
    public history: Array<ApprovalHistory> = new Array<ApprovalHistory>();
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.load();
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.load();
    }

    public async approvalAccepted(id: string): Promise<void> {
        await approvalApi.acceptAsync(id);
        const approval = await approvalApi.fetchByIdAsync(id);
        const history = await approvalApi.fetchHistoryByIdAsync(id);
        this.approval = approval;
        this.history = history;
    }
    public async approvalRejected(id: string): Promise<void> {
        await approvalApi.rejectAsync(id);
        const approval = await approvalApi.fetchByIdAsync(id);
        const history = await approvalApi.fetchHistoryByIdAsync(id);
        this.approval = approval;
        this.history = history;
    }
    public async load(): Promise<void> {
        try {
            const approval = await approvalApi.fetchByIdAsync(this.$route.params.id);
            const history = await approvalApi.fetchHistoryByIdAsync(this.$route.params.id);
            this.approval = approval;
            this.history = history;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                this.$router.push({ name: 'not-found' });
            }
        }
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.load();
        this.isLoading = false;
    }
}
